'use client';

/**
 * SysObeyaKpiModulesAffectedCard — Complexity Hotspots KPI tile.
 *
 * Slices `response.totals.modules_affected` from the system_obeya_view
 * high_cc_functions call. Hero number is the count of distinct modules
 * carrying at least one high-CC function — spread indicator.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_modules_affected"
 * @see klyde_edge/ui_config/labels/system_obeya.py — high_cc_kpi_modules_affected_*
 */

import { Layers } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiModulesAffectedCard({ view_name = 'high_cc_functions' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_modules_affected"
      label={L.high_cc_kpi_modules_affected_label ?? ''}
      Icon={Layers}
      value={isLoading ? '…' : fmt(t.modules_affected)}
      queryKey={queryKey}
    />
  );
}
